import React from 'react';
import { useWatch } from 'react-hook-form';
import productTypes, { ProductTypes } from '../../../../constants/productTypes';
import SwishProductInformation from './swishProductInformation';
import LineOfBusinessProductInformation from './lineOfBusinessProductInformation';
import InvoiceProductInformation from './InvoiceProductInformation';

const productInformationInputs: Record<ProductTypes, React.FC> = {
  [productTypes.INVOICE]: InvoiceProductInformation,
  [productTypes.LINE_OF_BUSINESS]: LineOfBusinessProductInformation,
  [productTypes.SWISH]: SwishProductInformation,
};

const ProductInformationInput = () => {
  const productType = useWatch<{
    productType?: ProductTypes;
  }>({ name: 'productType' });

  if (!productType) return null;

  const Input = productInformationInputs[productType];
  return <Input />;
};

export default ProductInformationInput;
